import { render, staticRenderFns } from "./MaterialPreviewModal.vue?vue&type=template&id=716e5e75"
import script from "./MaterialPreviewModal.vue?vue&type=script&lang=js"
export * from "./MaterialPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports